import { useCallback, useRef, useState } from "react";
export function useSnapCarousel(count: number) {
  const ref = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const onScroll = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    if (max <= 0) return;
    setIndex(Math.round((el.scrollLeft / max) * (count - 1)));
  }, [count]);
  const scrollTo = useCallback(
    (i: number) => {
      const el = ref.current;
      if (!el) return;
      const max = el.scrollWidth - el.clientWidth;
      el.scrollTo({ left: (max * i) / Math.max(1, count - 1), behavior: "smooth" });
    },
    [count]
  );
  return { ref, index, onScroll, scrollTo };
}
